import hljs from 'highlight.js';
import 'highlight.js/scss/a11y-dark.scss';

hljs.highlightAll();